var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vernier" }, [
    _vm.percent !== -1
      ? _c("span", { staticClass: "dot", style: [_vm.offsetStyle] })
      : _vm._e(),
    _vm._v(" "),
    _vm.secPercent !== -1
      ? _c("span", { staticClass: "secDot", style: [_vm.offsetStyleSec] })
      : _vm._e(),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "horizon" }, [
      _c("span", { staticClass: "division" }),
      _vm._v(" "),
      _c("span", { staticClass: "division" }),
      _vm._v(" "),
      _c("span", { staticClass: "division" }),
      _vm._v(" "),
      _c("span", { staticClass: "division" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }